jQuery(document).ready(function() {
  	
  	Shopify.queue = [];
  
  	var current_item_list_errors = [];
  
  	jQuery('.var_qty').val(0).trigger("change");
  
  	/* Android - Chrome browser Fix to allow numbers only when type in qty. box */
  	if(/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {	
  		jQuery(".var_qty").prop('type','number');
   	} else {                       
   		jQuery(".var_qty").prop('type','text');
   	}
  
   	/* Allow to type number only in qty. box */
    function isNumber(evt) 
  	{
   	 	evt = (evt) ? evt : window.event;
   	 	var charCode = (evt.which) ? evt.which : evt.keyCode;
    	
      	if(charCode > 31 && (charCode < 48 || charCode > 57)) {
    	return false;
    	}
    	return true;
    }
  
  	/* Reset current List after Multicart performed - Cart Request Complete  */
   	jQuery(document).on('cart.requestComplete',function(event,cart) {
      	 
      	  //Update Cart Count
          jQuery('#CartCount').html(cart.item_count); 
          
          if(current_item_list_errors.length == Shopify.queue.length) {
              jQuery("#acp-overlay").removeClass("ajaxcartpro-box-show").addClass("ajaxcartpro-box-hide");
              jQuery('html,body').animate({ scrollTop: $(".product-single__price").offset().top }, 600);
         } else {
              if(current_item_list_errors.length == 0) { 
              	window.location.href='/cart';
              } else {
              	jQuery("#acp-overlay").removeClass("ajaxcartpro-box-hide").addClass("ajaxcartpro-box-show");
              	jQuery("#cartDrawer").css("display","block");
              }
            }
          
          	current_item_list_errors = [];
       		Shopify.queue = [];
          	jQuery("#ajaxcartpro-progress").removeClass("ajaxcartpro-box-show").addClass("ajaxcartpro-box-hide");
    		jQuery("p").remove(".err_text");
    		jQuery('.var_qty').val(0).trigger("change");
          	jQuery("#Variant-AddToCart-product-template").prop("disabled",false);      
   	});                    
  
  
  	/* On key press check its number or alphabets have been typed */
    jQuery(document).on('keypress','.var_qty',function(evt) {
       var isno = isNumber(evt);
       if(!isno) {
         return false;
       }
    });
  
  	/* On qty. entered by user then push current variant with qty in multicart queue */
   	jQuery(document).on('keyup','.var_qty',function(e) {
        e.preventDefault();
        
      	var ele_id = jQuery(this).attr("id");
        var var_id = ele_id.replace("var_qty_", "");
    	var qtyInput = jQuery("#"+ele_id);
        var var_qty = parseInt(qtyInput.val()) || 0;
      	var qtyMax = parseInt(qtyInput.attr('max'));
     
      	/* Stock Management */
     	if(var_qty > qtyMax) {
        	alert("We have maximum "+qtyMax+" items in stock.");
   		 	qtyInput.val(qtyMax);	
      		var_qty = qtyMax;       
       } 
       
     	/* If Variant is already added then update it's qty. */
      	Shopify.queue = jQuery.grep(Shopify.queue, function(e){ 
    		if(e.variantId == var_id) {
       		return false;
     		} else {
       		return true;
        	}
      	});   
     
      	/* Push Variants in Queue for adding all to cart */
  		Shopify.queue.push({variantId: var_id,quantity: var_qty });
   });
  
   /* Add to cart button clicked */
   jQuery("#Variant-AddToCart-product-template").on("click",function(e) {
    	e.preventDefault();
     
     	jQuery(".multicart_err").css("display","none");
     	jQuery(".multicart_err > p").remove();
     	jQuery("#cartDrawer").find(".cartText").html("");
     
     	if(Shopify.queue.length == 0) {
          alert("Sorry! No Items were added, Please fill Quantity field first then click on Add to Cart button.");
        } else {
     		jQuery("#Variant-AddToCart-product-template").prop("disabled",true);
    		Shopify.moveAlong();
        }
   });
  
   /* Multiajax Add to Cart - Rivets JS Function */
   Shopify.moveAlong = function() {
     	 var err_cnt = 0;
    
     	 //If we still have requests in the queue, let's process the next one.
	 	 if(Shopify.queue.length>0) {
           
           	var qty_cnt = 0;
           
          	jQuery("#ajaxcartpro-progress").removeClass("ajaxcartpro-box-hide").addClass("ajaxcartpro-box-show");
            jQuery("#acp-overlay").removeClass("ajaxcartpro-box-hide").addClass("ajaxcartpro-box-show");
                  
           	jQuery.each(Shopify.queue, function(i,v){
          		CartJS.addItem(this.variantId, this.quantity,{}, {
          			"success": function(data,textStatus,jqXHR){
                    		qty_cnt = qty_cnt+Shopify.queue[i].quantity;
                    	  	jQuery("#cartDrawer").find(".cartText").html("<span class='cart_msg''>"+qty_cnt+" Items are added to Cart successfully.</span>");
          			},
          			"error": function(jqXHR){
            				err_cnt++;
                  			var response = eval('(' + jqXHR.responseText + ')');
            				response = response.description;
                  			current_item_list_errors.push({'err_res':response});
            				jQuery(".multicart_err").css("display","block");
                  			jQuery(".multicart_err").append("<p>Error-"+err_cnt+": "+response+"</p>");
          			}
      			});
           });
      	} 
   };
  
   /* Close Popup */
   jQuery(".closeDrawer,#acp-overlay,.continue-shopping").on("click",function(e) {
    	jQuery("#acp-overlay").removeClass("ajaxcartpro-box-show").addClass("ajaxcartpro-box-hide");
   	 	jQuery("#cartDrawer").hide();
   });
});
